<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
    .row
      .col-sm-12
        input(type="checkbox" v-model="toggleValue")
        label.ml5 Toggle All
    .row
      .col-sm-3(v-for="fv in filterValues")
        label.unbold
          input(type="checkbox" v-model="fv.selected")
          span.ml5 {{ fv.name }}
    hr
    GenericTable()
      tr(slot="thead")
        th Type
        th User
        th Data
        th Timestamp
      tr(v-for="(e, index) in sortedEvents")
        td {{ e.type }}
        td
          span(v-if="e.user && e.user.username") {{ e.user.username}}
          span(v-if="e.username") {{ e.username }}
        td
          span(v-if="e.type === 'CodesProducedEvent'")
            .fa.fa-plus-square
            span.ml5 Order
              router-link(:to="{ name: 'order', params: { id: e.orderId } }") {{ e.orderId }}
              span was topped up with {{ e.totalNumberOfCodes | number }} codes
          span(v-else-if="e.type === 'SectionCreatedEvent'")
            .fa.fa-plus-square
            span.ml5 Section created for order
            router-link(:to="{ name: 'order', params: { id: e.orderId }}")  {{ e.orderId }}
          span(v-else-if="e.type === 'LoginSuccessfulEvent'")
            .fa.fa-check
            span.ml5 Login from IP-address {{ e.ipAddress }} using {{ e.userAgent }} was successful
          span(v-else-if="e.type === 'LoginUnsuccessfulEvent'")
            .fa.fa-ban
            span.ml5 Login from IP-address {{ e.ipAddress }} failed
          span(v-else-if="e.type === 'ValidationEvent'") Validated code {{ e.code }}, valid={{ e.result.valid }}
          span(v-else-if="e.type === 'VanguardAlertEvent'")
            .fa.fa-shield
            span.ml5 Linked issue
            span(v-for="li in e.linkedIssue")
              a(:href="`#/policy/vanguard/alert-details/${li}`") {{ li }}
          div(v-else-if="e.type === 'TreeUploadedEvent'")
            .fa.fa-cubes
            span.ml5 Packing tree
            .bold  {{ e.revisionId }}
            span  with size {{ e.size | number }} uploaded from {{ e.uploadLocation.name }}
            ul(v-for="i in e.inventory")
              li {{ i.packageName }}
                span(v-if="i.productName")  - {{ i.productName }} = {{ i.count | number }}
            span Code from order(s):
            span(v-for="orderId in e.referredOrders")
              router-link(:to="{ name: 'order', prarms: { id: orderId }}")  {{ orderId }}
          span(v-else-if="e.type === 'ExpansionStatusChangedEvent'")
            .fa.fa-gear
            span.ml5 Expansion {{ e.expansionId }} with {{ e.totalNumberOfCodes | number }} code from order
            router-link(:to="{ name: 'order', params: { id: e.orderId }}")  {{ e.orderId }}
            span  changed status to {{ e.status }}
          div(v-else-if="e.type === 'CodeStatusChangedEvent'")
            div(v-if="e.invalidCodeCount") Invalid Codes: {{ e.invalidCodeCount | number }}
            div(v-if="e.codeStatusDeltas.length")
              .fa.fa-gear
              span.ml5 Code statuses updated
              ul(v-for="delta in e.codeStatusDeltas")
                li Order {{ delta.order.id }}
                  ul(v-for="(k, v) in delta.updatedStatusCounts")
                    li {{ k }} = {{ v }}
          span(v-else-if="e.type === 'RegisterTrackingEvent'")
            .fa.fa-location-arrow
            router-link.kzcode-default(:to="{ name: 'trace', params: { code: e.event.code.code }}") {{ e.event.code.code }}
            span  was registered at {{ e.event.location.name }} with {{ e.event.businessStep }} - {{ e.event.disposition }}
          span(v-else-if="e.type === 'ErrorEvent'")
            .fa.fa-warning
            span.ml5 {{ e.errorCode }} - {{ e.errorMessage.substring(0,15) }}
          span(v-else) {{ e }}
        td {{ e.eventTime | date }}
        td(v-if="events.length < 1" colspan="4") No Events yet
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import { numberFilter, dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    events: [],
    filterValues: [
      {
        name: 'Codes Produced', type: 'CodesProducedEvent', selected: true, key: 'A'
      },
      {
        name: 'Login Successful', type: 'LoginSuccessfulEvent', selected: true, key: 'B'
      },
      {
        name: 'Login Unsuccessful', type: 'LoginUnsuccessfulEvent', selected: true, key: 'C'
      },
      {
        name: 'Section Created', type: 'SectionCreatedEvent', selected: true, key: 'D'
      },
      {
        name: 'Validation Event', type: 'ValidationEvent', selected: true, key: 'E'
      },
      {
        name: 'Vanguard Alert', type: 'VanguardAlertEvent', selected: true, key: 'F'
      },
      {
        name: 'Tree Uploaded', type: 'TreeUploadedEvent', selected: true, key: 'G'
      },
      {
        name: 'Expansion Status Changed', type: 'ExpansionStatusChangedEvent', selected: true, key: 'H'
      },
      {
        name: 'Code Status Changed', type: 'CodeStatusChangedEvent', selected: true, key: 'I'
      },
      {
        name: 'Register Tracking', type: 'RegisterTrackingEvent', selected: true, key: 'J'
      },
      {
        name: 'Error', type: 'ErrorEvent', selected: true, key: 'K'
      }
    ],
    toggleValue: false,
    urlQueryKeys: null
  }),
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.toggleValue = true
      const eventStream = new EventSource('/ssp/common/v1/eventstream')
      eventStream.onmessage = (event) => {
        const data = JSON.parse(event.data)
        this.events.unshift(data)
      }
      this.setFilterSelection()
    },
    setFilterSelection() {
      this.filterValues.forEach((val) => {
        const fv = val
        if (this.$route.query.key && this.$route.query.key.includes(fv.key)) {
          fv.selected = true
        } else {
          fv.selected = false
        }
      })
    }
  },
  computed: {
    sortedEvents() {
      return this.events.filter((e) => this.filterValues.some((v) => v.selected && v.type === e.type))
    }
  },
  watch: {
    toggleValue() {
      this.filterValues.forEach((f) => {
        const filter = f
        filter.selected = this.toggleValue
      })
    },
    filterValues: {
      handler() {
        const keyString = this.filterValues.filter((v) => v.selected).map((v) => v.key).join('')
        this.$router.push({ query: { key: keyString } })
      },
      deep: true
    }
  },
  filters: {
    number: numberFilter,
    date: dateFilter
  },
  components: {
    GenericTable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/system/Events.vue